


















import { defineComponent, PropType } from '@nuxtjs/composition-api'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import { Seller } from '~/models/classified/types'
export default defineComponent({
  components: { CHybridTelephone },
  props: {
    seller: {
      type: Object as PropType<Seller>,
      required: true
    }
  }
})
